import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { useState, useEffect } from 'react';
import { Container } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { IconButton } from '../../../navigation/buttons/IconButton/IconButton.js';

function TableHorizontalScroll(props) {
  var tableRef = props.tableRef;
  var _useState = useState([]),
    nodes = _useState[0],
    setNodes = _useState[1];
  useEffect(function () {
    var tableContainerElement = tableRef.current;
    if (tableContainerElement) {
      var elements = Array.from(tableContainerElement.querySelectorAll('tbody tr:first-child > td'));
      setNodes(elements);
    }
  }, [tableRef]);
  var handlePrev = function handlePrev() {
    var tableContainerElement = tableRef.current;
    if (tableContainerElement) {
      var reversedNodesCopy = [].concat(nodes).reverse();
      var prevNode = reversedNodesCopy.find(function (node) {
        var _tableContainerElemen = tableContainerElement.getBoundingClientRect(),
          left = _tableContainerElemen.left;
        var _node$getBoundingClie = node.getBoundingClientRect(),
          nodeLeft = _node$getBoundingClie.left;
        return Math.ceil(nodeLeft) < Math.ceil(left);
      });
      tableContainerElement.scroll({
        left: (prevNode === null || prevNode === void 0 ? void 0 : prevNode.offsetLeft) || 0,
        behavior: 'smooth'
      });
    }
  };
  var handleNext = function handleNext() {
    var tableContainerElement = tableRef.current;
    var stickyElem = nodes.find(function (node) {
      return node.getAttribute('data-sticky-column') === 'right';
    });
    if (tableContainerElement) {
      var _tableContainerElemen2 = tableContainerElement.getBoundingClientRect(),
        right = _tableContainerElemen2.right;
      var _ref = (stickyElem === null || stickyElem === void 0 ? void 0 : stickyElem.getBoundingClientRect()) || {},
        stickyLeft = _ref.left;
      var viewportRight = stickyLeft || right;
      var nextNode = nodes.find(function (node) {
        var _node$getBoundingClie2 = node.getBoundingClientRect(),
          nodeRight = _node$getBoundingClie2.right;
        return Math.floor(nodeRight) > Math.floor(viewportRight);
      });
      if (nextNode) {
        var _nextNode$getBounding = nextNode.getBoundingClientRect(),
          nodeRight = _nextNode$getBounding.right;
        tableContainerElement.scrollBy({
          left: Math.ceil(nodeRight) - Math.ceil(viewportRight),
          behavior: 'smooth'
        });
      }
    }
  };
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsx(IconButton, {
      appearance: "ghost",
      onClick: handlePrev,
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        $color: "gray.600",
        icon: faChevronLeft
      })
    }), /*#__PURE__*/jsx(IconButton, {
      appearance: "ghost",
      onClick: handleNext,
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        $color: "gray.600",
        icon: faChevronRight
      })
    })]
  });
}

export { TableHorizontalScroll };
